import { render, staticRenderFns } from "./insSpecification.vue?vue&type=template&id=1ca2345a&"
import script from "./insSpecification.vue?vue&type=script&lang=js&"
export * from "./insSpecification.vue?vue&type=script&lang=js&"
import style0 from "./insSpecification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports